'use strict';

exports.__esModule = true;
exports.default = reducer;

var _seamlessImmutable = require('seamless-immutable');

var _actionCreators = require('./action-creators');

var _filter = require('../constants/filter');

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    capabilities: [],
    filterValue: _filter2.default.MARKETPLACE,
    searchQuery: '',
    marketplace: [],
    allResults: [],
    apps: [],
    services: [],
    contentTypes: [],
    autocompleteTerms: [],
    suggest: [],
    recentQueries: [],
    showResults: false,
    serviceLookup: {},
    highlightIndex: -1,
    savedQuery: '',
    resultUrl: '',
    userId: null // AppWise User ID
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _seamlessImmutable.static.from(INITIAL_STATE);
    var action = arguments[1];

    switch (action.type) {
        case _actionCreators.ACTIONS.SET_FILTER_VALUE:
            return _seamlessImmutable.static.merge(state, { filterValue: action.filterValue });
        case _actionCreators.ACTIONS.SET_SEARCH_QUERY:
            return _seamlessImmutable.static.merge(state, { searchQuery: action.searchQuery });
        case _actionCreators.ACTIONS.SET_SHOW_RESULTS:
            return _seamlessImmutable.static.merge(state, { showResults: action.show });
        case _actionCreators.ACTIONS.SET_ALL_RESULTS:
            return _seamlessImmutable.static.merge(state, { allResults: action.results });
        case _actionCreators.ACTIONS.SET_MARKETPLACE_RESULTS:
            return _seamlessImmutable.static.merge(state, { marketplace: action.results });
        case _actionCreators.ACTIONS.SET_APP_RESULTS:
            return _seamlessImmutable.static.merge(state, { apps: action.results });
        case _actionCreators.ACTIONS.SET_SERVICE_RESULTS:
            return _seamlessImmutable.static.merge(state, { services: action.results });
        case _actionCreators.ACTIONS.SET_CONTENT_TYPE_RESULTS:
            return _seamlessImmutable.static.merge(state, { contentTypes: action.results });
        case _actionCreators.ACTIONS.SET_SUGGEST_RESULTS:
            return _seamlessImmutable.static.merge(state, { suggest: action.results });
        case _actionCreators.ACTIONS.SET_AUTOCOMPLETE_RESULTS:
            return _seamlessImmutable.static.merge(state, { autocompleteTerms: action.results });
        case _actionCreators.ACTIONS.SET_RECENT_QUERIES:
            return _seamlessImmutable.static.merge(state, { recentQueries: action.results });
        case _actionCreators.ACTIONS.SET_CAPABILITIES:
            return _seamlessImmutable.static.merge(state, { capabilities: action.capabilities });
        case _actionCreators.ACTIONS.SET_SERVICES:
            return _seamlessImmutable.static.merge(state, { serviceLookup: action.services });
        case _actionCreators.ACTIONS.SET_SAVED_QUERY:
            return _seamlessImmutable.static.merge(state, { savedQuery: action.savedQuery });
        case _actionCreators.ACTIONS.SET_RESULT_HIGHLIGHT:
            return _seamlessImmutable.static.merge(state, { highlightIndex: action.index });
        case _actionCreators.ACTIONS.SET_RESULT_SELECTION:
            return _seamlessImmutable.static.merge(state, { resultUrl: action.url });
        case _actionCreators.ACTIONS.SET_USER_ID:
            return _seamlessImmutable.static.merge(state, { userId: action.userId });
        default:
            return state;
    }
}